import React from 'react';

const SentimentGauge = ({ sentiment, size = 'md' }) => {
  const score = sentiment?.average_score || 0;
  const label = sentiment?.overall_label || 'neutral';
  
  // Size configurations
  const sizes = {
    sm: { width: 'w-32', height: 'h-20', textSize: 'text-xs' },
    md: { width: 'w-48', height: 'h-28', textSize: 'text-sm' },
    lg: { width: 'w-64', height: 'h-36', textSize: 'text-base' }
  };
  
  const config = sizes[size] || sizes.md;
  
  // Convert score (-1 to 1) to angle (-90 to 90 degrees)
  const angle = score * 90;
  
  // Color based on sentiment
  const getColor = () => {
    if (label === 'positive') return 'text-green-500';
    if (label === 'negative') return 'text-red-500';
    return 'text-yellow-500';
  };
  
  const getGaugeColor = () => {
    if (label === 'positive') return '#10b981';
    if (label === 'negative') return '#ef4444';
    return '#eab308';
  };

  return (
    <div className={`flex flex-col items-center ${config.width}`}>
      {/* Gauge SVG */}
      <div className={`relative ${config.height}`}>
        <svg viewBox="0 0 200 120" className="w-full h-full">
          {/* Background arc */}
          <path
            d="M 20 100 A 80 80 0 0 1 180 100"
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="12"
            strokeLinecap="round"
          />
          
          {/* Colored segments */}
          <path
            d="M 20 100 A 80 80 0 0 1 66.7 36.6"
            fill="none"
            stroke="#ef4444"
            strokeWidth="12"
            strokeLinecap="round"
            opacity="0.3"
          />
          <path
            d="M 66.7 36.6 A 80 80 0 0 1 133.3 36.6"
            fill="none"
            stroke="#eab308"
            strokeWidth="12"
            strokeLinecap="round"
            opacity="0.3"
          />
          <path
            d="M 133.3 36.6 A 80 80 0 0 1 180 100"
            fill="none"
            stroke="#10b981"
            strokeWidth="12"
            strokeLinecap="round"
            opacity="0.3"
          />
          
          {/* Needle */}
          <line
            x1="100"
            y1="100"
            x2="100"
            y2="30"
            stroke={getGaugeColor()}
            strokeWidth="3"
            strokeLinecap="round"
            transform={`rotate(${angle} 100 100)`}
            className="transition-transform duration-500"
          />
          
          {/* Center dot */}
          <circle cx="100" cy="100" r="6" fill={getGaugeColor()} />
        </svg>
      </div>
      
      {/* Score and label */}
      <div className={`text-center mt-2 ${config.textSize}`}>
        <div className={`font-bold ${getColor()}`}>
          {score > 0 ? '+' : ''}{score.toFixed(2)}
        </div>
        <div className="text-gray-600 capitalize">{label}</div>
        {sentiment?.positive_percentage !== undefined && (
          <div className="text-xs text-gray-500 mt-1">
            {sentiment.positive_percentage}% pos / {sentiment.negative_percentage}% neg
          </div>
        )}
      </div>
    </div>
  );
};

export default SentimentGauge;
